// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.JeJ6L{display:flex;flex-direction:column}@media(min-width: 992px){.JeJ6L{max-width:calc(100% - 30px) !important;min-height:100%}.JeJ6L+.JeJ6L{margin-top:30px}}.JeJ6L.QXOka{margin-bottom:30px}.XmgI_{flex:1 1;flex-shrink:0;height:100%;margin:0;min-height:500px;width:100%}@media(min-width: 992px){.XmgI_{border:2px solid var(--whitelabeling-primary-color);border-radius:2px;-webkit-box-sizing:border-box;box-sizing:border-box}}@media(max-width: 991px){.XmgI_{height:calc(100% - 50px);margin-top:50px;min-height:200px}}.XmgI_+.XmgI_{margin-top:20px}.MGbk3.KQ9WE{height:100%;width:100% !important}@media(max-width: 991px){.MGbk3.KQ9WE{padding:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "JeJ6L",
	"last": "QXOka",
	"iframe": "XmgI_",
	"modal": "MGbk3",
	"modalOverride": "KQ9WE"
};
module.exports = ___CSS_LOADER_EXPORT___;
